/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import TextInputModal from "../../../molecules/modals/TextInputModal";
import { useFormattedMsg } from "../../../../hooks/useFormatMsg";
import { TextPromptModalDescriptor } from "./types";

export type Props = {
  descriptor: TextPromptModalDescriptor;
};

const GlobalTextPromptModal: FC<Props> = ({ descriptor }) => {
  const fallbackTitle = useFormattedMsg("common.enter_text");

  const { title, initialValue, required, placeholder, resolve } = descriptor;

  const handleAccept = (inputValue: string) => resolve(inputValue);
  const handleDecline = () => resolve(false);

  return (
    <TextInputModal
      isOpen
      onAccept={handleAccept}
      toggleModal={handleDecline}
      initialValue={initialValue}
      required={required}
      placeholder={placeholder}
      title={title || fallbackTitle}
    />
  );
};

export default GlobalTextPromptModal;
export type GlobalTextPromptModalProps = Props;
